<ng-container *ngIf="results | async as results$; else loading">
  <fuel-gauge-new
                  [results]="results$"
                  [options]="options"
                  min="0"
                  max="100"
                  [legend]="true"
                  (select)="onSelect($event)">
  </fuel-gauge-new>
</ng-container>

<!--<fuel-gauge-new *ngIf="results.length > 0"
                [results]="results"
                [options]="options"
                min="0"
                max="100"
                [legend]="true"
                (select)="onSelect($event)">
</fuel-gauge-new>-->

<ng-template #loading>
  <div style="color:gray; display: block; margin: auto; height: 100%">
    <div style="display: flex;">
      <span class="fa fa-spinner fa-pulse fa-5x" style=" color:gray;"></span>
    </div>
  </div>
</ng-template>


<!--{{controlValue}}-->
